define("shared/types/instagram", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.InstagramMediaType = _exports.InstagramMediaProductType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  let InstagramMediaType;
  _exports.InstagramMediaType = InstagramMediaType;

  (function (InstagramMediaType) {
    InstagramMediaType["Image"] = "IMAGE";
    InstagramMediaType["Video"] = "VIDEO";
    InstagramMediaType["CarouselAlbum"] = "CAROUSEL_ALBUM";
  })(InstagramMediaType || (_exports.InstagramMediaType = InstagramMediaType = {}));

  let InstagramMediaProductType;
  _exports.InstagramMediaProductType = InstagramMediaProductType;

  (function (InstagramMediaProductType) {
    InstagramMediaProductType["Ad"] = "AD";
    InstagramMediaProductType["Feed"] = "FEED";
    InstagramMediaProductType["Story"] = "STORY";
    InstagramMediaProductType["Reels"] = "REELS";
  })(InstagramMediaProductType || (_exports.InstagramMediaProductType = InstagramMediaProductType = {}));
});